"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FABAuth = void 0;
const helper_1 = require("./helper");
class FABAuth {
    /** Init */
    init() {
        this.RedirectLogout();
    }
    /** Redirect Logout */
    RedirectLogout() {
        jQuery('.fab-container .fab-links').each(function () {
            let type = helper_1.FABHelper.getAttribute(jQuery(this).data('id'), 'type');
            if (type === 'auth_logout') {
                jQuery(this).on('click', function () {
                    window.FAB_PLUGIN.logout_url = helper_1.FABHelper.getAttribute(jQuery(this).data('id'), 'link');
                    setTimeout(function () {
                        let doc = new DOMParser().parseFromString(window.FAB_PLUGIN.logout_url, "text/html");
                        window.location.href = doc.documentElement.textContent;
                    }, 3000);
                });
            }
        });
    }
}
exports.FABAuth = FABAuth;
